const nlHome = {
  topBar: {
    phone: "040 798 7470 — Ma-Zo 08:00-20:00",
    email: "info@ramen-repair-eindhoven.nl",
  },
  header: {
    logo: "Ramen Repair Eindhoven",
    nav: {
      diensten: "Diensten",
      wijken: "Wijken",
      realisaties: "Realisaties",
      overOns: "Over ons",
      contact: "Contact",
    },
    cta: "Gratis offerte",
  },
  hero: {
    pill: "KOZIJNSPECIALIST EINDHOVEN — SINDS 2015",
    h1: "Kozijn- en raamreparatie in Eindhoven",
    subhead: "Snel, vakkundig en met 10 jaar garantie. PVC, aluminium en hout — wij herstellen het.",
    ctaPrimary: "Gratis offerte in 24u",
    ctaPhone: "040 798 7470",
    reviews: "Toonaangevende klantbeoordelingen op Google",
  },
  logoWall: {
    title: "Wij werken met originele onderdelen van:",
    brands: ["Roto", "Winkhaus", "Maco", "Sobinco", "SKG", "M&C"],
  },
  diensten: {
    h2: "Onze diensten in Eindhoven",
    items: [
      {
        title: "Kozijnreparatie",
        desc: "Herstel van kromgetrokken kozijnen, scheuren en vervanging van beschadigde delen. Wij werken met PVC, aluminium en hout.",
        price: "vanaf €85",
        link: "/kozijn-reparatie/",
      },
      {
        title: "Schuifpui reparatie",
        desc: "Rollers vervangen, rails herstellen, sluitwerk afstellen en vloeiende beweging van uw schuifpui garanderen.",
        price: "vanaf €95",
        link: "/schuifpui-reparatie/",
      },
      {
        title: "Draaikiepraam reparatie",
        desc: "Precisie-afstelling en reparatie van draai- en kiepmechanisme voor optimale werking en tochtklachten verhelpen.",
        price: "vanaf €75",
        link: "/draaikiepraam-reparatie/",
      },
      {
        title: "Glas vervangen HR++",
        desc: "Professionele vervanging van enkelglas naar isolerend HR++ glas voor lagere energiekosten en meer comfort.",
        price: "op offerte",
        link: "/glas-vervangen/",
      },
      {
        title: "Slot- en cilindervervanging",
        desc: "Directe vervanging van defecte sloten en cilinders met SKG*** gekeurde producten voor maximale veiligheid.",
        price: "vanaf €85",
        link: "/slot-cilinder-vervangen/",
      },
      {
        title: "Velux dakraam reparatie",
        desc: "Reparatie en onderhoud van Velux dakramen inclusief rubbers, vervanging van sluitwerk en condensatiepreventie.",
        price: "vanaf €125",
        link: "/velux-reparatie/",
      },
      {
        title: "Inbraakschade reparatie",
        desc: "24/7 spoedservice na inbraak of poging tot inbraak. Wij beveiligen, herstellen en regelen uw verzekering.",
        price: "Vanaf €165",
        link: "/inbraakschade-reparatie/",
      },
      {
        title: "Raamkruk vervangen",
        desc: "Versleten kruk? Wij vervangen alle merken in elke kleur — wit, RAL, RVS, chroom of brons. Vanaf €85.",
        price: "Vanaf €85",
        link: "/raamkruk-vervangen/",
      },
    ],
  },
  realisaties: {
    h2: "Recente projecten in Eindhoven",
    items: [
      { location: "Strijp-S", desc: "Schuifpui rollers vervangen — Strijp-S" },
      { location: "Woensel", desc: "Slot SKG*** geplaatst na inbraak — Woensel" },
      { location: "Centrum", desc: "Kozijnreparatie monumentaal pand — Centrum" },
      { location: "Tongelre", desc: "Draaikiepraam reparatie na renovatie — Tongelre" },
      { location: "Gestel", desc: "HR++ glas vervangen in rijtjeshuis — Gestel" },
      { location: "Veldhoven", desc: "Velux dakraam mechanisme hersteld — Veldhoven" },
    ],
  },
  subsidie: {
    h2: "HR++ glas plaatsen? Profiteer van subsidies in 2026.",
    body: "Bespaar tot €600/jaar. Wij adviseren over ISDE-regeling en gemeentelijke subsidies in Eindhoven. Lees meer over ISDE-subsidie 2026.",
    cta: "ISDE-subsidie 2026",
  },
  wijken: {
    h2: "Waar wij actief zijn in Eindhoven",
    districts: [
      "Centrum",
      "Strijp",
      "Woensel",
      "Stratum",
      "Gestel",
      "Tongelre",
    ],
    omstreken: [
      { name: "Veldhoven", time: "~15 min" },
      { name: "Geldrop", time: "~15 min" },
      { name: "Nuenen", time: "~15 min" },
      { name: "Helmond", time: "~20 min" },
      { name: "Best", time: "~20 min" },
      { name: "Waalre", time: "~20 min" },
      { name: "Son en Breugel", time: "~20 min" },
    ],
  },
  waarom: {
    h2: "Waarom kiezen voor Ramen Repair Eindhoven?",
    reasons: [
      {
        nr: "01",
        title: "Eigen monteurs uit Brabant",
        desc: "Geen onderaannemers, vakkennis sinds 2015. Onze eigen teams kennen elke wijk in Eindhoven.",
      },
      {
        nr: "02",
        title: "Originele onderdelen voorraad",
        desc: "Roto, Winkhaus, Maco, Sobinco direct beschikbaar. Wij installeren alleen A-merken met garantie.",
      },
      {
        nr: "03",
        title: "Transparante prijzen vooraf",
        desc: "Vanaf €75, geen verrassingen. Duidelijke prijsopgave per e-mail binnen 24 uur na aanvraag.",
      },
      {
        nr: "04",
        title: "10 jaar schriftelijke garantie",
        desc: "Op werken en onderdelen. Onze garantiebepalingen zijn helder en zonder kleine lettertjes.",
      },
    ],
  },
  reviews: {
    h2: "Wat klanten zeggen",
    score: "Uitstekend",
    stars: "5",
    subtitle: "Toonaangevende klantbeoordelingen op Google",
    testimonials: [
      {
        name: "Bart V.",
        area: "Strijp-S",
        text: "Schuifpui rolde weer soepel binnen 2 uur. Prijs was zoals afgesproken. Aanrader!",
      },
      {
        name: "Linda H.",
        area: "Woensel-Noord",
        text: "Na een inbraak moest het slot snel vervangen worden. Binnen 4 uur ter plaatse. Top service.",
      },
      {
        name: "VvE De Hofkamp",
        area: "Tongelre",
        text: "20 draaikiepramen afgesteld in één dag. Geen klachten meer van bewoners over tocht.",
      },
    ],
  },
  faq: {
    h2: "Veelgestelde vragen",
    items: [
      { q: "Hoe snel kunt u ter plaatse zijn?", a: "In Eindhoven en directe omgeving zijn wij doorgaans binnen 4 tot 24 uur ter plaatse. Bij spoedgevallen zoals een inbraak streven wij naar binnen 2 uur." },
      { q: "Mijn raam sluit niet meer goed. Wat zijn de kosten?", a: "Dit hangt af van de oorzaak. Afstellen start vanaf €75. Bij vervanging van sluitwerk of rubbers rekent u vanaf €85. Wij geven altijd een prijsopgave vooraf." },
      { q: "Kunt u ook houten ramen repareren?", a: "Zeker. Wij repareren zowel PVC, aluminium als houten kozijnen. Bij hout herstellen wij rotte delen, vervangen we sponningen en voeren we voegwerk uit." },
      { q: "Werken jullie ook 's avonds en in het weekend?", a: "Ja, wij zijn beschikbaar van maandag tot zondag van 08:00 tot 20:00. Voor spoedgevallen buiten deze tijden kunt u ons bereiken via de telefonische storingslijn." },
      { q: "Wat houdt de 10 jaar garantie in?", a: "Onze garantie dekt zowel de arbeid als de gebruikte onderdelen. Bij defecten binnen 10 jaar komen wij kosteloos terug voor reparatie of vervanging." },
      { q: "Werken jullie ook voor VvE's?", a: "Ja, wij hebben veel ervaring met appartementencomplexen en VvE's. Wij bieden bundelkortingen aan bij grotere projecten en verzorgen heldere facturatie per woning." },
      { q: "Wat is HR++ glas en waarom zou ik het overwegen?", a: "HR++ glas is dubbelglas met een coating die warmte binnen houdt. Het bespaart tot €600 per jaar op stookkosten en verhoogt het wooncomfort. Wij adviseren u graag over subsidies." },
      { q: "Welke betaalmethoden accepteren jullie?", a: "Wij accepteren pin, contant, overschrijving en betaling in termijnen bij grotere projecten. Voor VvE's werken wij op factuurbasis." },
    ],
  },
  ctaBanner: {
    h2: "Direct hulp nodig in Eindhoven?",
    cta: "Bel 040 798 7470",
  },
  offerte: {
    h2: "Gratis offerte aanvragen",
    steps: ["Probleem", "Materiaal", "Contactgegevens"],
    step1: {
      label: "Waar heeft u last van?",
      options: [
        "Kozijn of raam is krom / sluit niet",
        "Schuifpui loopt stroef",
        "Draaikiepraam werkt niet goed",
        "Slot of cilinder defect",
        "Glas is gebarsten / condens",
        "Velux dakraam lekt / werkt niet",
        "Anders / weet ik niet zeker",
      ],
    },
    step2: {
      label: "Welk materiaal is uw kozijn?",
      options: ["PVC", "Aluminium", "Hout", "Weet ik niet"],
    },
    step3: {
      name: "Naam",
      email: "E-mailadres",
      phone: "Telefoonnummer",
      address: "Adres in Eindhoven",
      message: "Extra opmerkingen (optioneel)",
      submit: "Offerte aanvragen",
      back: "Terug",
      next: "Volgende",
    },
  },
  footer: {
    col1: {
      title: "Informatie",
      links: [
        { label: "Algemene Voorwaarden", href: "/algemene-voorwaarden/" },
        { label: "Privacybeleid", href: "/privacybeleid/" },
        { label: "Cookiebeleid", href: "/cookiebeleid/" },
        { label: "Sitemap", href: "/sitemap.xml" },
        { label: "Contact", href: "/contact/" },
      ],
    },
    col2: {
      title: "Diensten",
      links: [
        { label: "Kozijnreparatie", href: "/kozijn-reparatie/" },
        { label: "Schuifpui reparatie", href: "/schuifpui-reparatie/" },
        { label: "Draaikiepraam reparatie", href: "/draaikiepraam-reparatie/" },
        { label: "Glas vervangen HR++", href: "/glas-vervangen/" },
        { label: "Slot- en cilindervervanging", href: "/slot-cilinder-vervangen/" },
        { label: "Velux dakraam", href: "/velux-reparatie/" },
        { label: "Inbraakschade", href: "/inbraakschade-reparatie/" },
        { label: "Raamkruk vervangen", href: "/raamkruk-vervangen/" },
      ],
    },
    col3: {
      title: "Wijken",
      links: [
        { label: "Strijp", href: "/wijken/" },
        { label: "Woensel", href: "/wijken/" },
        { label: "Centrum", href: "/wijken/" },
        { label: "Tongelre", href: "/wijken/" },
        { label: "Gestel", href: "/wijken/" },
        { label: "Stratum", href: "/wijken/" },
      ],
    },
    col4: {
      title: "Contact",
      phone: "040 798 7470",
      email: "info@ramen-repair-eindhoven.nl",
      hours: "Ma — Zo: 08:00 – 20:00",
      area: "Eindhoven & omstreken",
    },
    bottom: {
      copyright: "© 2026 Ramen Repair Eindhoven",
      kvk: "KvK",
      btw: "BTW",
      av: "AV",
      privacy: "Privacy",
    },
  },
  stickyMobile: "Bel direct",
};

export default nlHome;